import {FbAuctionCardConfiguration} from "./fb-auction-card/fb-auction-card.configuration";

export class FbAuctionConfiguration {


    get auctions(): Array<FbAuctionConfigurationAuctions> {
        return this._auctions;
    }

    private set auctions(value: Array<FbAuctionConfigurationAuctions>) {
        this._auctions = value;
    }

    private _auctions: Array<FbAuctionConfigurationAuctions> = [];

    title? : string;

    public setAuctions(value: Array<FbAuctionConfigurationAuctions>) {

        this.auctions = [...value];
    }

    public setTitle(value : string) : FbAuctionConfiguration {

        this.title = value;
        return this;

    }

    constructor() {
    }

    public static create = (): FbAuctionConfiguration => new FbAuctionConfiguration;


}

export class FbAuctionConfigurationAuctions {

    auctions: FbAuctionCardConfiguration[] = new Array<FbAuctionCardConfiguration>();
    tabConfiguration: FbTabConfiguration | null = null;
    private constructor() {
    }

    public static create = () => new FbAuctionConfigurationAuctions();

    setAuctions(value: FbAuctionCardConfiguration[]) {

        this.auctions = value;
        return this;

    }

    setTabConfiguration(value: FbTabConfiguration) {

        this.tabConfiguration = value;
        return this;
    }


}

export class FbTabConfiguration {

    title : string | null = null;

    constructor(title : string) {

        this.title = title;
    }

    public static create = (title : string) => new FbTabConfiguration(title);

}
